module.exports = __webpack_public_path__ + "img/icon_aside_excel2_active.8d26ef1e.svg";